import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ExpandPanelComponent } from '../../core/panels/expand-panel.component';
import { ColumnComponent } from '../../core/table/column.component';
import { TableComponent, TableTheme } from '../../core/table/table.component';

type PolicyLayout = 'claim' | 'policy' | 'plan-summary';

@Component({
  selector: 'app-policy-attributes',
  imports: [
    CommonModule,
    TableComponent,
    ColumnComponent,
    ExpandPanelComponent,
  ],
  template: `<app-table
    #table
    [dataSource]="dataSource"
    [pageSize]="pageSize"
    [scrollable]="false"
    recordLabel="Attribute"
    [canExpand]="canExpand"
    dataKey="id"
    [theme]="theme"
  >
    @if (layout === 'policy') {
      <app-column name="attributeType" label="Name" width="15%" />
      <app-column
        name="attributeTypeDesc"
        label="Name Description"
        width="15%"
      />
      <app-column name="attributeValue" label="Value" width="15%" />
      <app-column
        name="attributeValueDesc"
        label="Value Description"
        width="15%"
      />
      <app-column name="attributeCategory" label="Category" width="12%" />
      <app-column
        name="attributeSubCategory"
        label="Sub Category"
        width="12%"
      />
      <app-column name="fieldType" label="Field Type" width="13%" />
      <app-column name="deleted" label="Deleted" width="8%" format="b" />
    } @else if (layout === 'plan-summary') {
      <app-column name="name" label="Name" width="16%" />
      <app-column name="nameDescription" label="Name description" width="16%" />
      <app-column name="value" label="Value" width="16%" />
      <app-column
        name="valueDescription"
        label="Value description"
        width="16%"
      />
      <app-column name="fieldType" label="Field type" width="16%" />
      <app-column name="deleted" label="Deleted" width="20%" format="b" />
    } @else {
      <app-column name="attributeType" label="Type" width="20%" />
      <app-column name="attributeValue" label="Value" width="20%" />
      <app-column name="attributeCategory" label="Category" width="20%" />
      <app-column
        name="attributeSubCategory"
        label="Sub category"
        width="20%"
      />
      <app-column name="deleted" label="Deleted" width="20%" format="b" />
    }
    <app-expand-panel
      [expanded]="table.expanded"
      label="Attribute"
      collapseHeight="80px"
    >
    </app-expand-panel>
  </app-table>`,
  styles: [],
})
export class PolicyAttributesComponent {
  @Input()
  showEmpty = false;

  @Input()
  theme: TableTheme = 'Light';

  @Input()
  dataSource: any;

  @Input()
  source: any;

  @Input()
  layout: PolicyLayout = 'claim';

  @Input()
  pageSize = 5;

  canExpand(row: any): boolean {
    return Object.values(row).some((field) => field?.toString()?.trim());
  }
}
